import { useState } from 'react';
import { useMutation } from 'react-apollo';
import { mutations } from '@kiper/account-graphql/invite';
import { OPEN_STATUS } from '../settings';

const useOpenGuestSmartLock = ({ guestHash }) => {
  const [status, setStatus] = useState(OPEN_STATUS.IDLE);
  const [openGuestSmartLock] = useMutation(mutations.openGuestSmartLock);

  const handleOpenSmartLock = async () => {
    setStatus(OPEN_STATUS.LOADING);
    try {
      const response = await openGuestSmartLock({ variables: { guestHash } });
      setStatus(
        response?.data?.openGuestSmartLock
          ? OPEN_STATUS.SUCCESS
          : OPEN_STATUS.ERROR,
      );
    } catch {
      setStatus(OPEN_STATUS.ERROR);
    }
  };

  return { status, handleOpenSmartLock };
};

export default useOpenGuestSmartLock;
